import React from 'react';
import styled from 'styled-components';

// STYLE-COMPONENTS
// ===================================
const PublicLayout = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: ${p => p.theme.color.background};
`;

// EXPORT
// ===================================
export default ({ children, style, theme }) => (
  <PublicLayout theme={theme} style={style}>
    {children}
  </PublicLayout>
);



// WEBPACK FOOTER //
// ./src/components/layout/PublicLayout/index.js